import React from 'react'
import { create, Jss, SheetsRegistry } from 'jss'
import jssPresetDefault from 'jss-preset-default'
import { Baseline } from '@airbus/elements/elements'
import defaultTheme from './defaultTheme'

// FIXME workaround for rollup/jss misconfiguration
// @see https://github.airbus.corp/Airbus/design-system/issues/1753
let preset = jssPresetDefault
if (typeof jssPresetDefault !== 'function') preset = (jssPresetDefault as any).default

// Default JSS instance.
const jss = create(preset())
const baselineSheet = jss.createStyleSheet(Baseline(defaultTheme)).attach()

export const StylesContext: React.Context<{
  jss: Jss
  registry: SheetsRegistry
  baseline: any
}> = React.createContext({
  jss,
  registry: new SheetsRegistry(),
  baseline: baselineSheet,
})
